import { render, staticRenderFns } from "./VacationCalendar.vue?vue&type=template&id=60468b55&scoped=true"
import script from "./VacationCalendar.vue?vue&type=script&lang=js"
export * from "./VacationCalendar.vue?vue&type=script&lang=js"
import style0 from "./VacationCalendar.vue?vue&type=style&index=0&id=60468b55&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60468b55",
  null
  
)

export default component.exports